
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.5 13.5v5a1 1 0 001 1h7a1 1 0 001-1v-5h-9zm6 4h-3a1 1 0 110-2h3a1 1 0 110 2z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M17 14.5a1 1 0 001-1v-6a1 1 0 00-1-1H1c-.551 0-1 .449-1 1v6a1 1 0 001 1h1.5v-3h13v3H17z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M13.5.5h-9c-.551 0-1 .449-1 1v3h11v-3a1 1 0 00-1-1z","fill":"currentColor"}})])
          )
        }
      }
    